<template>
    <div class="page-header-wrapper" v-if="isAuthenticated">
        <div class="page-header-wrapper-inner">
            <router-link class="mobile-logo-wrapper" to="/">
                <v-Icon class="mobile-logo" alt="FPS - logo" name="logo" />
            </router-link>
            <h1 v-if="forceTitleString && forceTitleString !== ''" class="page-title">
                {{ forceTitleString }}
            </h1>
            <h1 v-else-if="data && data.title && data.title !== ''" class="page-title">
                {{ data.title }}
            </h1>
            <h1 v-else-if="$route.meta.pageName && $route.meta.pageName !== ''" class="page-title">
                {{ $route.meta.pageName }}
            </h1>

            <nav id="side-nav" class="side-nav" v-if="getCurrentUser">
                <ul>
                    <li class="contains-sub-menu">
                        <button class="mini-user-wrapper">
                            <transition name="fade">
                                <div class="user-icon-wrapper" v-if="showMiniUser">
                                    <span class="company-logo" v-if="companyLogo"><img :src="companyLogo"
                                            alt="company logo" /></span>
                                    <span class="initials">{{ getCurrentUser?.firstName?.charAt(0) }}</span>
                                </div>
                            </transition>
                            <span class="user-name">
                                {{ getCurrentUser?.firstName }} {{ getCurrentUser?.lastName }}
                            </span>
                        </button>
                        <ul class="sub-menu">
                            <li><router-link to="/account">Account</router-link></li>
                            <li><button @click="handleLogout()">Logout</button></li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import { defineComponent, computed, ref, watchEffect, onMounted, onUnmounted, watch } from 'vue'

import { useRoute } from 'vue-router'
import { useAuthenticationData } from '@/composables/useAuthenticationData'
import { useMetaManager } from '@/composables/useMetaManager'
import { useGlobalStore } from '@/stores/global'
import { useCurrentUserData } from '@/composables/useUserData'
import { useCompanyLogo } from '@/composables/useCompanyLogo'
import { clearData } from '@streampac.io/chef_sp_1'

import { useRouter } from 'vue-router'
import { is } from 'date-fns/locale'

export default defineComponent({
  components: {},
  props: {
    data: {
      type: Object,
      required: false
    },
    forceTitleString: {
      type: String,
      required: false
    }
  },
  setup(props) {
    const isAuthenticated = computed(() => {
      return useAuthenticationData().data.value.isAuthenticated
    })

    const $route = useRoute()
    const $router = useRouter()

    const globalStore = useGlobalStore()

    const { getCurrentUser } = useCurrentUserData()
    const { companyLogo, isLoadingLogo, fetchCompanyLogo, isLogoAvailable } = useCompanyLogo()

    const showMiniUser = ref(true)

    // Watch for changes in user data and customer group lookup
    watch(
      [getCurrentUser, () => globalStore?.getCustomerGroupLookup],
      () => {
        // Only fetch if both user data and customer group lookup are available
        // and we haven't fetched the logo yet
        if (getCurrentUser.value && globalStore?.getCustomerGroupLookup && !isLogoAvailable.value) {
          fetchCompanyLogo()
        }
      },
      { deep: true, immediate: true }
    )

    // Also watch for authentication changes
    watch(isAuthenticated, () => {
      if (getCurrentUser.value && globalStore?.getCustomerGroupLookup && !isLogoAvailable.value) {
        fetchCompanyLogo()
      }
    })

    function handleLogout() {
      clearData()
      useAuthenticationData().setAuthenticated(false)

      globalStore.storeRemoveAuthenticatedStatus()
      globalStore.deleteUserSavedData()

      $router.replace({ name: 'Home' })
    }

    return {
      isAuthenticated,
      getCurrentUser,
      companyLogo,
      isLoadingLogo,
      showMiniUser,
      isLogoAvailable,
      handleLogout
    }
  }
})
</script>
<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
